import {  faFileCircleCheck, faTrash } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useEffect, useRef, useState } from "react"
import PulseLoader from "react-spinners/PulseLoader";
import { useAddNewUploadMutation } from '../features/uploads/uploadApiSlice';
import getFilePath from "../utils/getFilePath"

function Uploader({label, folderId, file, setFile, required, isImg}) {
  const [selectedFile, setSelectedFile] = useState();
  const inputRef = useRef(null);
    useEffect(() => {

      if (selectedFile) {
        handleSubmission()
      }

  }, [selectedFile])
  
    const [upload, {
          isLoading,
          isSuccess,
          isError,
          error,
          data
      }] = useAddNewUploadMutation()
      useEffect(() => {

        if (isSuccess && ( data.location || data.webLocation)) {
          setFile({location:data.location||'', name:data.name, webLocation:data.webLocation || ''})
          setSelectedFile('')
          inputRef.current.value = null;
        }
    
    }, [isSuccess])
    const errClass = (isError ) ? "errmsg" : "offscreen"
    const errContent = (error?.data?.message ) ?? ''
    const changeHandler = (event) => {
      setSelectedFile(event.target.files[0]);
      //setIsSelected(true);
    }
    const handleSubmission = async () => {
      const formData = new FormData();
      formData.append('file', selectedFile);
           upload({folderId,file:formData })
         
          
    }
	const handleRemoveFile = () =>{
		setFile('')
		setSelectedFile('')
		inputRef.current.value = null;
	}

    const validBodyClass = !file && required ? "form__input--incomplete" : ''

  return (
    <>
     <p className={errClass}>{errContent}</p>
     <div className={validBodyClass}>
       <div className="form__row">
                <label className="form__label" htmlFor="file">
                {label? label: 'File'}</label>   
                        </div>
                        <input  ref={inputRef} type="file" name="file" onChange={changeHandler} />
                        {
                        file &&
                         
               <>
			   <div className="uploader-grid form__input--ltr"  >     
			   <FontAwesomeIcon onClick={handleRemoveFile} className="icon-button status--open" icon={faTrash} />

<FontAwesomeIcon className="icon-button status--completed" icon={faFileCircleCheck} />
<a target="_blank"  className=" " href={getFilePath(file)}>
                          <h2 className="status--completed" >
  {file.name}
                          </h2>  </a>
						  {isImg ? <a target="_blank"  className=" " href={getFilePath(file)}><img className="upload-img" src={ getFilePath(file)} /></a> : <span></span>}

                          
                        
						  </div>  
						  </>  
                          
                       
                        }
			<div>
       {(isLoading) && <PulseLoader color={"#FFF"} />}
			</div>
      </div>
    </>
   
  )
}

export default Uploader